import "babel-polyfill";
import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";
import "./common/styles/index.css";
import registerServiceWorker from "./registerServiceWorker";

// only require react-axe (accessibility tool) in non-prod
if (process.env.NODE_ENV !== "production") {
    var axe = require("@axe-core/react");
    axe(React, ReactDOM, 1000);
}

ReactDOM.render(
    <App />,
    document.getElementById("root") as HTMLElement
);
registerServiceWorker();
